'use es6';

import keyMirror from 'react-utils/keyMirror';
import { FOLLOW_UP_EMAIL } from 'ContentUtils/constants/CustomWidgetFieldTypes';
export default Object.freeze(keyMirror({
  [FOLLOW_UP_EMAIL]: null
}));